
export default function ActionsFooter({
  darkMode,
  isProFeaturesLocked,
  isFeedbackEnabled,
  isRateAppEnabled,
  onDarkModeChange,
  onCustomizeShortcut,
  onHelpClick,
  onFeedbackClick,
  onRateAppClick,
  onChangelogClick,
}) {
  const darkModeDisabled = isProFeaturesLocked;

  return (
    <div className="actions">
      <div className="actions__list">
        <button
          type="button"
          className={`actions__toggle ${darkMode ? "actions__toggle--active" : ""}`}
          disabled={darkModeDisabled}
          onClick={() => onDarkModeChange(!darkMode)}
        >
          {darkMode ? "Light mode" : "Dark mode"}
        </button>
        {!isProFeaturesLocked && (
          <a href="#!" onClick={onCustomizeShortcut}>
            Shortcuts
          </a>
        )}
        <a href="#!" onClick={onHelpClick}>
          Help
        </a>
        {isFeedbackEnabled && (
          <a href="#!" onClick={onFeedbackClick}>
            Feedback
          </a>
        )}
        {isRateAppEnabled && (
          <a href="#!" onClick={onRateAppClick}>
            Rate App
          </a>
        )}
        <a href="#!" onClick={onChangelogClick}>
          v{process.env.VERSION}
        </a>
      </div>
    </div>
  );
}
